import './default.scss';

import { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';

import Breadcrumb from '@/resources/components/global/breadcrumb/Breadcrumb';
import { useTextColor } from '@/resources/hooks/useTextColor';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { getPrivacyPolicy } from '@/routes/settings';

function Default() {
  const { privacyPolicy, configs } = useWebContext();
  const color = useTextColor(configs.bg_color);

  useEffect(() => {
    getPrivacyPolicy();
  }, []);

  return (
    <Container fluid className="breakpoint-page">
      <Row>
        <Col md={12}>
          <Breadcrumb name="Política de Privacidade" />

          <div className="privacy-policy-section py-3" style={{ color }}>
            <section>
              <ReactMarkdown>{privacyPolicy ?? ''}</ReactMarkdown>
            </section>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Default;
